import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import * as microsoftTeams from "@microsoft/teams-js";
import { Canvas } from "@templates";
import { Loader } from "@atoms";

const scopes: string[] = (import.meta.env.MAPIQ_AUTH_LOGIN_SCOPES ?? "")
  .split(",")
  .map((scope: string) => scope.trim());

export const TeamsSignIn = () => {
  const { instance } = useMsal();

  useEffect(() => {
    const doAuth = async () => {
      try {
        const response = await instance.handleRedirectPromise();
        if (response) {
          microsoftTeams.authentication.notifySuccess(
            JSON.stringify({
              msalAccount: response.account,
              localStorage: { ...localStorage },
            }),
          );
        } else {
          instance.loginRedirect({
            scopes,
            redirectUri: window.location.origin,
          });
        }
      } catch (err) {
        microsoftTeams.authentication.notifyFailure((err as Error).message || "Login failed");
      }
    };

    microsoftTeams.app.initialize().then(doAuth);
  }, [instance]);

  return (
    <Canvas centerContent>
      <Loader />
    </Canvas>
  );
};
